import {
  FETCH_COURSE_SETTINGS_SUCCESS,
  FETCH_USER_SETTINGS_SUCCESS,
  UPDATE_SETTINGS,
  SAVE_SETTINGS_SUCCESS,
} from '../actions/settingsActions';

const initialState = {
  settings: null,
  userCourses: [],
  settingsFound: false,
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COURSE_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload,
        settingsFound: true,
      };
    case FETCH_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        userCourses: action.payload,
      };
    case UPDATE_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    case SAVE_SETTINGS_SUCCESS:
      return state; // Optionally handle state change on save
    default:
      return state;
  }
};

export default settingsReducer;
